<p-dialog
    [(visible)]="visible"
    appendTo="body"
    [closable]="true"
    [closeOnEscape]="false"
    [modal]="true"
    header="NHS Access"
    [style]="{ 'max-width': '330px', width: '100%' }">
    <ng-template pTemplate="content">
        <div class="dialog-content">
            <label> {{ labelMessage }} </label>
            <p-button *ngIf="!oneMonthRequest" class="firstStepButton" type="button" label="Request Access" (click)="openSecondStep()">
            </p-button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog
    [(visible)]="secondStepVisible"
    appendTo="body"
    [closable]="true"
    [closeOnEscape]="false"
    [modal]="true"
    header="Request"
    [style]="{ 'max-width': '210px', width: '100%' }">
    <ng-template pTemplate="content">
        <div class="dialog-content">
            <label> <h4>Request Full Access?</h4> </label>
            <div class="mt-2">
                <button
                    type="button"
                    pButton
                    icon="pi pi-times"
                    label="No"
                    class="p-button-secondary mr-2"
                    (click)="closeSecondStep()"
                    rte="4T"></button>
                <button
                    type="button"
                    pButton
                    icon="pi pi-check"
                    label="Yes"
                    class="m-button-primary"
                    (click)="confirmSecondStep()"
                    rte="4U"></button>
            </div>
        </div>
    </ng-template>
</p-dialog>
